import { render, staticRenderFns } from "./FormExportImport.vue?vue&type=template&id=d65080be&scoped=true"
import script from "./FormExportImport.vue?vue&type=script&lang=js"
export * from "./FormExportImport.vue?vue&type=script&lang=js"
import style0 from "./FormExportImport.vue?vue&type=style&index=0&id=d65080be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65080be",
  null
  
)

export default component.exports